<mat-card appearance="outlined" class="mission-card" *ngIf="!onEditMode">
  <mat-card-header>
    <mat-card-title>
      <div class="actionsCardTitle">
        <a (click)="getBack()" class="linkGetBack">
          <mat-icon>navigate_before</mat-icon> retour
        </a>
        <button
          *ngIf="!order.isDeleted && isDispatcher && order.status === 1"
          mat-raised-button
          class="action-button"
          color="primary"
          [disabled]="isLoading"
          [matTooltip]="'orders.list.receivedByDispatcher' | translate"
          (click)="changeStatus('receivedByDispatcher', order)"
        >
          Recevoir la commande
        </button>
        <button
          *ngIf="!order.isDeleted && isDispatcher && order.status === 2"
          mat-raised-button
          class="action-button"
          color="primary"
          [disabled]="isLoading"
          [matTooltip]="'orders.list.cancelled' | translate"
          (click)="changeStatus('cancelled', order)"
        >
          Annuler la commande
        </button>
        <button
          *ngIf="
            (!order.isDeleted && isDispatcher && order.status === 8) ||
            (!order.isDeleted &&
              isDispatcher &&
              order.status !== 16 &&
              order.status !== 32)
          "
          mat-raised-button
          class="action-button"
          color="primary"
          [disabled]="isLoading"
          [matTooltip]="'orders.list.finished' | translate"
          (click)="changeStatus('finished', order)"
        >
          Terminer la commande
        </button>
        <div [matTooltip]="invalidMessage" [matTooltipDisabled]="canEdit">
          <button
            *ngIf="!order.isDeleted"
            mat-raised-button
            class="action-button"
            color="primary"
            [disabled]="isLoading || !canEdit"
            matTooltip="Modifier la commande"
            (click)="updateOrder()"
          >
            Modifier la commande
          </button>
        </div>
      </div>
      <h3>
        Infos de la commande
        <button
          *ngIf="isSuperAdmin && !editInfos"
          (click)="modifyInfos()"
          mat-raised-button
          color="primary"
          type="button"
        >
          Modifier
        </button>
        <button
          *ngIf="isSuperAdmin && editInfos"
          (click)="validateNewInfos()"
          mat-raised-button
          color="primary"
          [disabled]="formInfos.invalid || formInfos.pristine"
          type="button"
        >
          Valider
        </button>
        <button
          *ngIf="isSuperAdmin && editInfos"
          (click)="cancelNewInfos()"
          mat-raised-button
          color="primary"
          class="cancelButton"
          type="button"
        >
          Annuler
        </button>
      </h3>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <section class="wrapperContainer">
      <ul class="left-list listHeader">
        <li class="titleStatus">
          <h1>N° trans {{ order.identifier }}</h1>
          <span class="label">Statut</span>
          <span *ngIf="order.status">{{
            showStatusText(order.status) | translate
          }}</span>
        </li>

        <li class="created-by" *ngIf="!isRestricted">
          Créé le {{ order.createdOn | amDateFormat: "DD/MM/YYYY HH:mm" }}
          par
          <span class="username" *ngIf="order.createdBy">{{
            order.createdBy.username
          }}</span>
          <span class="username" *ngIf="!order.createdBy">Système</span>
          <ng-container *ngIf="order.modifiedOn">
            , <br />
            Modifié le
            {{ order.modifiedOn | amDateFormat: "DD/MM/YYYY HH:mm" }}
            par
            <span class="username" *ngIf="order.modifiedBy">{{
              order.modifiedBy.username
            }}</span>
            <span class="username" *ngIf="!order.modifiedBy">Système</span>
          </ng-container>
        </li>

        <li class="siteSection">
          <span class="label">Agence</span>
          <span *ngIf="order.client && !editInfos">{{ order.client.name }}</span>
          <form
            [formGroup]="formInfos"
            *ngIf="isSuperAdmin && editInfos && !isLoadingClients && formInfos"
          >
            <app-autocomplete
              label="users.edit.clients.select.label"
              class="client-field"
              [control]="getControlClient()"
              [list]="clients"
            >
            </app-autocomplete>
          </form>
          <mat-spinner
            *ngIf="isLoadingClients"
            [diameter]="35"
            color="primary"
          ></mat-spinner>
        </li>

        <li class="siteSection">
          <span class="label">Donneur d'ordre</span>
          <span *ngIf="order.site && !editInfos">{{ order.site.name }}</span>
          <!-- <button *ngIf="isSuperAdmin" (click)="modifySite()" mat-raised-button color="primary"
            type="button">Modifier</button> -->
          <form
            [formGroup]="formInfos"
            *ngIf="isSuperAdmin && editInfos && !isLoadingSites && formInfos"
          >
            <app-autocomplete
              label="orders.create.site.label"
              class="site-field"
              [control]="getControlSite()"
              [list]="filteredSites"
              errorMsg="orders.create.site.errorMessage"
            >
            </app-autocomplete>
            <!-- <button (click)="validateNewSite()" mat-raised-button color="primary" type="button">Valider</button>
            <button (click)="cancelNewSite()" mat-raised-button color="primary" type="button">Annuler</button> -->
          </form>
          <mat-spinner
            *ngIf="isLoadingSites"
            [diameter]="35"
            color="primary"
          ></mat-spinner>
        </li>

        <li>
          <span class="label">Nom du demandeur</span>
          <span *ngIf="order.ordererName">{{ order.ordererName }}</span>
        </li>

        <li>
          <span class="label">Téléphone du demandeur</span>
          <span *ngIf="order.ordererPhone">{{ order.ordererPhone }}</span>
        </li>

        <li *ngIf="isDispatcher">
          <span class="label">Type de commande</span>
          <span>
            {{ showTypeText(order.type) | translate }}
          </span>
        </li>

        <li>
          <span class="label">Nom</span>
          <span *ngIf="!editInfos">
            {{ order.name }}
          </span>
          <form *ngIf="editInfos" [formGroup]="formInfos">
            <mat-form-field>
              <mat-label>Nom</mat-label>
              <input matInput type="text" formControlName="name" />
            </mat-form-field>
          </form>
        </li>

        <li *ngIf="isTour()">
          <span class="label">Code tournée</span>
          <span>{{ order.code }}</span>
        </li>

        <li *ngIf="isTour() && canSeeTourPrices">
          <span class="label">Prix</span>
          <span *ngIf="order.price && !editInfos"> {{ order.price }} € </span>
          <form
            [formGroup]="formInfos"
            *ngIf="isSuperAdmin && editInfos && !isLoadingSites && formInfos"
          >
            <mat-form-field>
              <mat-label>Prix</mat-label>
              <input type="number" min="0" matInput formControlName="price" />
            </mat-form-field>
          </form>
        </li>

        <li *ngIf="isTour() && canSeeTourPrices">
          <span class="label">Prix (étapes supplémentaires)</span>
          <span *ngIf="order.extraStepPrice && !editInfos">
            {{ order.extraStepPrice }} €
          </span>
          <form
            [formGroup]="formInfos"
            *ngIf="isSuperAdmin && editInfos && !isLoadingSites && formInfos"
          >
            <mat-form-field>
              <mat-label>Prix (étapes supplémentaires)</mat-label>
              <input
                type="number"
                min="0"
                matInput
                formControlName="extraStepPrice"
              />
            </mat-form-field>
          </form>
        </li>
      </ul>

      <ul class="middle-list listHeader">
        <li>
          <span class="label">Niveau d'urgence</span>
          <span *ngIf="order.urgency && !editInfos">{{
            order.urgency.name
          }}</span>
          <form
            [formGroup]="formInfos"
            *ngIf="
              isSuperAdmin && editInfos && !isLoadingUrgencies && formInfos
            "
          >
            <app-autocomplete
              label="orders.create.urgencyLevel"
              class="urgency-field"
              [control]="getControlUrgency()"
              [list]="urgencies"
              errorMsg="orders.create.urgency.errorMessage"
            >
            </app-autocomplete>
            <!-- <button (click)="validateNewSite()" mat-raised-button color="primary" type="button">Valider</button>
            <button (click)="cancelNewSite()" mat-raised-button color="primary" type="button">Annuler</button> -->
          </form>
          <mat-spinner
            *ngIf="isLoadingUrgencies"
            [diameter]="35"
            color="primary"
          ></mat-spinner>
        </li>

        <li>
          <fieldset>
            <legend class="label">Type de produits</legend>
            <ul *ngIf="order.transportTypes.length > 0">
              <li *ngFor="let type of order.transportTypes">
                {{ type.name }} - Température :
                <span class="temperature-info" *ngIf="type.temperature !== null && type.temperature !== undefined">
                  {{ type.temperature | signedTemperature }}°C
                </span>
                <span class="temperature-info" *ngIf="type.temperature === null || type.temperature === undefined">
                  N/A
                </span>
              </li>
            </ul>
            <span *ngIf="order.transportTypes.length === 0"
              >Aucun type de produits</span
            >
          </fieldset>
        </li>

        <li class="internal-comment" *ngIf="canSeeInternalComment">
          <fieldset>
            <legend class="label">
              Commentaire interne
              <mat-icon
                *ngIf="!editInternalCommentFlag"
                color="primary"
                matTooltip="Editer le commentaire interne"
                (click)="editInternalComment()"
              >
                edit_square
              </mat-icon>

              <button
                mat-icon-button
                *ngIf="editInternalCommentFlag"
                color="primary"
                matTooltip="Valider l'édition du commentaire interne"
                [disabled]="formInternalComment.invalid"
                (click)="validateEditionInternalComment()"
              >
                <mat-icon> check </mat-icon>
              </button>

              <button
                mat-icon-button
                *ngIf="editInternalCommentFlag"
                color="primary"
                matTooltip="Annuler l'édition du commentaire interne"
                (click)="closeEditionInternalComment()"
              >
                <mat-icon> close </mat-icon>
              </button>
            </legend>

            <p class="comment" *ngIf="!editInternalCommentFlag">
              {{ internalComment }}
            </p>

            <form
              *ngIf="editInternalCommentFlag"
              [formGroup]="formInternalComment"
            >
              <mat-form-field class="commentField">
                <textarea
                  matInput
                  rows="3"
                  formControlName="internalComment"
                ></textarea>
                <mat-error
                  >Le commentaire ne peut pas dépasser 500 caractères</mat-error
                >
              </mat-form-field>
            </form>
          </fieldset>
        </li>

        <li class="global-comment" *ngIf="order.ordererComment">
          <fieldset>
            <legend class="label">Commentaire</legend>
            <p class="comment" *ngIf="order.ordererComment">
              {{ order.ordererComment }}
            </p>
          </fieldset>
        </li>
      </ul>

      <ul class="right-list listHeader">
        <li class="global-driver">
          <form [formGroup]="driverForm">
            <div>
              <span class="label">Chauffeur </span>
              <span *ngIf="order.driver">{{ order.driver.username }}</span>
              <span *ngIf="!order.driver">Aucun chauffeur</span>

              <button
                class="driverButton"
                *ngIf="
                  !order.isDeleted &&
                  !showDrivers &&
                  isDispatcher &&
                  (order.status === 1 ||
                    order.status === 2 ||
                    order.status === 4 ||
                    order.status === 8 ||
                    order.status === 16 ||
                    order.status === 256)
                "
                mat-raised-button
                color="primary"
                type="button"
                (click)="openDrivers()"
              >
                Assigner
              </button>

              <button
                mat-raised-button
                color="primary"
                type="button"
                class="driverButton"
                *ngIf="order.driver && !showDrivers && order.status === 4"
                (click)="notifyDriver()"
                matTooltip="Notifier à nouveau le chauffeur"
              >
                Notifier à nouveau
              </button>

              <button
                class="driverButton"
                *ngIf="!order.isDeleted && showDrivers"
                mat-raised-button
                color="primary"
                type="button"
                (click)="confirmDriverChange()"
                [disabled]="driverForm.pristine"
              >
                Valider
              </button>
              <button
                class="driverButton"
                *ngIf="!order.isDeleted && showDrivers"
                mat-raised-button
                color="primary"
                type="button"
                (click)="cancelDriverChange()"
              >
                Annuler
              </button>
            </div>

            <ng-container *ngIf="!order.isDeleted && showDrivers">
              <br />
              <mat-form-field class="drivers-field" *ngIf="!isLoadingDrivers">
                <mat-label>Assigner un chauffeur</mat-label>
                <mat-select formControlName="driver">
                  <mat-option *ngFor="let driver of drivers" [value]="driver">
                    {{ driver.username }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="commentField">
                <mat-label>Commentaire</mat-label>
                <textarea
                  matInput
                  rows="3"
                  formControlName="comment"
                ></textarea>
              </mat-form-field>
              <mat-spinner
                *ngIf="isLoadingDrivers"
                [diameter]="35"
                color="primary"
              ></mat-spinner>
            </ng-container>
          </form>
        </li>

        <li>
          <span class="label">Véhicule</span>
          <span *ngIf="!editInfos && order.vehicle?.numberplate">{{
            order.vehicle.numberplate
          }}</span>
          <span *ngIf="!editInfos && !order.vehicle">aucun</span>

          <form
            [formGroup]="formInfos"
            *ngIf="isSuperAdmin && editInfos && formInfos"
          >
            <app-autocomplete
              class="site-field"
              [control]="getControlVehicle()"
              [list]="vehicles"
            >
            </app-autocomplete>
          </form>
        </li>

        <li *ngIf="order.status !== 16">
          <span class="label">Nombre de destination(s)</span>
          <span>{{ totalSteps }}</span>
        </li>

        <li>
          <span class="label">Date, heure de départ souhaitée</span>
          <span *ngIf="order.startDate && !editInfos">{{
            order.startDate | amDateFormat: "DD/MM/YYYY HH:mm"
          }}</span>
          <span *ngIf="order.startDate && editInfos">{{
            order.startDate | amDateFormat: "DD/MM/YYYY"
          }}</span>
          <form [formGroup]="formInfos" *ngIf="editInfos">
            <mat-form-field class="time-field">
              <mat-label>Heure</mat-label>
              <input type="time" matInput formControlName="startTime" />
            </mat-form-field>
          </form>
        </li>

        <li>
          <span class="label">Date, heure de livraison souhaitée</span>
          <span *ngIf="order.requestedDeliveryDate && !editInfos">{{
            order.requestedDeliveryDate | amDateFormat: "DD/MM/YYYY HH:mm"
          }}</span>
          <span *ngIf="order.requestedDeliveryDate && editInfos">{{
            order.requestedDeliveryDate | amDateFormat: "DD/MM/YYYY"
          }}</span>
          <form
            [formGroup]="formInfos"
            *ngIf="order.requestedDeliveryDate && editInfos"
          >
            <mat-form-field class="time-field">
              <mat-label>Heure</mat-label>
              <input
                type="time"
                matInput
                formControlName="requestedDeliveryTime"
              />
            </mat-form-field>
          </form>
        </li>
      </ul>
    </section>
  </mat-card-content>
  <mat-card-actions>
    <mat-progress-bar
      class="progress-bar"
      mode="indeterminate"
      color="primary"
      *ngIf="isLoading"
    ></mat-progress-bar>
  </mat-card-actions>
</mat-card>

<mat-card appearance="outlined" *ngIf="!onEditMode" class="resume-card">
  <mat-card-header>
    <mat-card-title>
      <span *ngIf="!isTour()"> Résumé produits </span>
      <span *ngIf="isTour()"> Résumé </span>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="resumeProducts">
    <div class="listContainers" *ngIf="!isTour()">
      <ul class="listPickedUpScans">
        <li
          *ngFor="
            let container of order.scansPickedGroupedByContainer | keyvalue
          "
        >
          <span class="label"
            >{{ container.value[0].container.productType.name }} expédié(s)
          </span>
          {{ container.value.length }}
        </li>
      </ul>

      <ul>
        <li
          *ngFor="
            let container of order.scansDeliveredGroupedByContainer | keyvalue
          "
        >
          <span class="label"
            >{{ container.value[0].container.productType.name }} livré(s)
          </span>
          {{ container.value.length }}
        </li>
      </ul>
    </div>

    <div *ngIf="isTour()">
      <ul>
        <li>
          <span class="label">Dernière étape</span>
          <span>
            {{ order.lastStepAddress() }}
          </span>
        </li>

        <li>
          <span class="label">Étape suivante</span>
          <span>
            {{ order.nextStepAddress() }}
          </span>
        </li>
        <li>
          <div style="width: 100%; font-size: 18px">
            {{ order.computePercentageCompleted() }} %
            <mat-progress-bar
              class="progress"
              mode="determinate"
              [value]="order.computePercentageCompleted()"
            >
            </mat-progress-bar>
          </div>
        </li>
      </ul>
    </div>

    <div *ngIf="isTour()">
      <ul>
        <li>
          <span class="label">Étapes</span>
          <span>
            {{ order.computeNbStep() }}
          </span>
        </li>

        <li>
          <span class="label">Complétés</span>
          <span>
            {{ order.computeNbStepDone() }}
          </span>
        </li>

        <li>
          <span class="label">Produits expédiés</span>
          <span>
            {{ order.countNbPickupScan() }}
          </span>
        </li>

        <li>
          <span class="label">Produits livrés</span>
          <span>
            {{ order.countNbDeliveryScan() }}
          </span>
        </li>
      </ul>
    </div>

    <ul class="actionButtonList">
      <li *ngIf="canExportRole" class="liLetter">
        <div *ngIf="!isTour()">
          <button
            mat-raised-button
            class="action-button"
            color="primary"
            matTooltip="Exporter en PDF la Lettre de voiture"
            (click)="onExportLetter()"
          >
            <mat-icon> picture_as_pdf </mat-icon>
            Lettre de voiture
          </button>

          <button
            mat-icon-button
            color="primary"
            class="export-btn"
            (click)="showEmailLetter()"
            matTooltip="Envoyer par mail la lettre de voiture"
          >
            <mat-icon aria-label="File">email</mat-icon>
          </button>
        </div>

        <ng-container *ngIf="showEmail && !isLoadingEmail">
          <form [formGroup]="formMail">
            <mat-form-field class="email-field">
              <mat-label>Email</mat-label>
              <input matInput type="email" formControlName="email" />
            </mat-form-field>

            <button
              mat-icon-button
              color="primary"
              class="export-btn"
              (click)="sendMailLetter()"
              [disabled]="formMail.invalid || formMail.pristine"
              matTooltip="Envoyer le mail"
            >
              <mat-icon aria-label="File">check</mat-icon>
            </button>

            <button
              mat-icon-button
              color="primary"
              class="export-btn"
              (click)="cancelMailLetter()"
              matTooltip="Annuler"
            >
              <mat-icon aria-label="File">clear</mat-icon>
            </button>
          </form>
        </ng-container>
        <mat-spinner
          *ngIf="isLoadingEmail"
          [diameter]="35"
          color="primary"
        ></mat-spinner>
      </li>

      <li>
        <button
          mat-raised-button
          *ngIf="!isLoadingRoadLetter"
          (click)="downloadAsPDF()"
          class="action-button"
          color="primary"
          matTooltip="Exporter en PDF la Feuille de route"
        >
          <mat-icon> picture_as_pdf </mat-icon>
          Feuille de route
        </button>
        <mat-spinner
          *ngIf="isLoadingRoadLetter"
          style="margin-left: 80px"
          color="primary"
          [diameter]="30"
        ></mat-spinner>
      </li>

      <li>
        <a href="https://app.koovea.fr/" target="_blank">
          <button
            mat-raised-button
            class="action-button"
            color="primary"
            matTooltip="Vers le suivi de température"
          >
            Suivi de température
          </button>
        </a>
      </li>
    </ul>
  </mat-card-content>
</mat-card>

<div class="actionsToggle" *ngIf="!onEditMode">
  <button mat-button (click)="accordion.openAll()">Tout développer</button>
  <button mat-button (click)="accordion.closeAll()">Tout réduire</button>
</div>
<mat-accordion class="example-headers-align" multi *ngIf="!onEditMode">
  <mat-expansion-panel *ngIf="order.patients.length > 0">
    <mat-expansion-panel-header>
      <mat-panel-title> Patients </mat-panel-title>
      <mat-panel-description>
        Liste des patients et leurs infos
        <mat-icon color="primary">recent_actors</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <section class="sectionTable">
      <mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z2 patientsTable"
        matSort
        #TablePatientsSort="matSort"
      >
        <ng-container matColumnDef="firstname">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Prénom
          </mat-header-cell>
          <mat-cell *matCellDef="let patient">
            {{ patient.firstname }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="birthname">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Nom de naissance
          </mat-header-cell>
          <mat-cell *matCellDef="let patient">
            {{ patient.birthname }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastname">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Nom
          </mat-header-cell>
          <mat-cell *matCellDef="let patient">
            {{ patient.lastname }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="birthdate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Date de naissance
          </mat-header-cell>
          <mat-cell *matCellDef="let patient">
            {{ patient.birthdate | amDateFormat: "DD/MM/YYYY" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="productType">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Type de produit
          </mat-header-cell>
          <mat-cell *matCellDef="let patient">
            {{ patient.productType }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="quantity">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Quantité
          </mat-header-cell>
          <mat-cell *matCellDef="let patient">
            {{ patient.quantity }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <mat-paginator
        #TablePatientsPaginator
        *ngIf="order.patients.length > 0"
        [pageSize]="4"
        [length]="order.patients.length"
        showFirstLastButtons
      ></mat-paginator>
    </section>
  </mat-expansion-panel>

  <!-- SENDER -->
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span *ngIf="!isTour()"> Expédition - </span>
        Étape 1

        <button
          *ngIf="isSuperAdmin && !order.sender.editMode"
          [disabled]="stepOnEditMode"
          (click)="modifyStep(this.order.sender); $event.stopPropagation()"
          mat-raised-button
          color="primary"
          type="button"
        >
          Modifier
        </button>
        <button
          *ngIf="isSuperAdmin && order.sender.editMode && formStep"
          (click)="validateNewStep(this.order.sender); $event.stopPropagation()"
          [disabled]="formStep.invalid || formStep.pristine"
          mat-raised-button
          color="primary"
          type="button"
        >
          Valider
        </button>
        <button
          *ngIf="isSuperAdmin && order.sender.editMode"
          (click)="cancelNewStep(this.order.sender); $event.stopPropagation()"
          mat-raised-button
          color="primary"
          class="cancelButton"
          type="button"
        >
          Annuler
        </button>
      </mat-panel-title>
      <mat-panel-description>
        <span class="italic" *ngIf="!isTour()"> Enlèvement</span>
        <mat-icon color="primary" *ngIf="!isTour()">local_shipping</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <section class="wrapperStep">
      <ul class="listPanel">
        <li *ngIf="order.sender.address && !order.sender.otherAddress">
          <span class="label">Nom d'adresse </span>
          <span *ngIf="!order.sender.editMode">{{
            order.sender.address.name
          }}</span>
        </li>

        <li *ngIf="order.sender.otherAddress">
          <span class="label">Nom d'adresse </span>
          <span *ngIf="!order.sender.editMode">{{
            order.sender.otherAddress
          }}</span>
        </li>

        <li *ngIf="order.sender.editMode && formStep" class="stepAddress">
          <form
            [formGroup]="formStep"
            *ngIf="!isLoadingAddresses && order.sender.editMode && formStep"
          >
            <app-autocomplete
              class="site-field stepAddress"
              [control]="getControlAddressStep()"
              [list]="senders"
              errorMsg="orders.create.sender.errorMessage"
              [canString]="canAddOtherAddress"
            >
            </app-autocomplete>
          </form>
        </li>

        <mat-spinner
          *ngIf="order.sender.editMode && isLoadingAddresses"
          [diameter]="35"
          color="primary"
        ></mat-spinner>

        <li>
          <span class="label">Service </span>
          <span *ngIf="!order.sender.editMode">{{ order.sender.service }}</span>

          <form
            [formGroup]="formStep"
            *ngIf="order.sender.editMode && formStep"
          >
            <app-autocomplete-text
              class="site-field stepAddress"
              [control]="getControlServiceStep()"
              [list]="getControlAddressStep().value?.services"
            >
            </app-autocomplete-text>
          </form>
        </li>

        <li *ngIf="order.sender.requestedDate">
          <span class="label">Date de passage souhaitée</span>
          {{ order.sender.requestedDate | amDateFormat: "DD/MM/YYYY HH:mm" }}
        </li>

        <li *ngIf="order.sender.hasSignature">
          <span class="label">Signataire </span>{{ order.sender.signatory }}
        </li>

        <li *ngIf="order.sender.hasSignature">
          <button
            mat-raised-button
            color="primary"
            (click)="downloadSignature(order.sender)"
          >
            Télécharger signature
          </button>
        </li>
      </ul>

      <ul>
        <li *ngIf="order.sender.address && !order.sender.otherAddress">
          <span class="label">Adresse complète </span>
          <span
            >{{ order.sender.address.street }}
            {{ order.sender.address.streetNumber }}
            {{ order.sender.address.locality }}
            {{ order.sender.address.postalCode }}</span
          >
        </li>

        <li *ngIf="order.sender.arrivedOn">
          <span class="label">Arrivée sur place </span>
          <span *ngIf="!order.sender.editMode">{{
            order.sender.arrivedOn | amDateFormat: "DD/MM/YYYY HH:mm"
          }}</span>
          <form
            [formGroup]="formStep"
            *ngIf="order.sender.editMode && formStep && !isLoadingAddresses"
          >
            <mat-form-field class="date-field">
              <mat-label>Arrivée sur place</mat-label>
              <input
                matInput
                [matDatepicker]="arrivedOnDate"
                (click)="arrivedOnDate.open()"
                (focus)="arrivedOnDate.open()"
                formControlName="arrivedOn"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="arrivedOnDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #arrivedOnDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="time-field">
              <mat-label>Heure</mat-label>
              <input type="time" matInput formControlName="arrivedTime" />
            </mat-form-field>
          </form>
          <mat-spinner
            *ngIf="order.sender.editMode && isLoadingAddresses"
            [diameter]="35"
            color="primary"
          ></mat-spinner>
        </li>

        <li *ngIf="order.sender.arrivedOn">
          <span class="label">Tag NFC </span>
          <span *ngIf="order.sender.tagScanned">{{
            order.sender.tagScanned
          }}</span>
          <span *ngIf="!order.sender.tagScanned">Aucun</span>
        </li>

        <li *ngIf="order.sender.completedOn">
          <span class="label" *ngIf="!isTour()">Expédié le </span>
          <span class="label" *ngIf="isTour()">Terminée le </span>
          <span *ngIf="!order.sender.editMode">{{
            order.sender.completedOn | amDateFormat: "DD/MM/YYYY HH:mm"
          }}</span>
          <form
            [formGroup]="formStep"
            *ngIf="order.sender.editMode && formStep && !isLoadingAddresses"
          >
            <mat-form-field class="date-field">
              <mat-label *ngIf="!isTour()">Expédié le</mat-label>
              <mat-label *ngIf="isTour()">Terminé le</mat-label>
              <input
                matInput
                [matDatepicker]="completedOnDate"
                (click)="completedOnDate.open()"
                (focus)="completedOnDate.open()"
                formControlName="completedOn"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="completedOnDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #completedOnDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="time-field">
              <mat-label>Heure</mat-label>
              <input type="time" matInput formControlName="completedTime" />
            </mat-form-field>
          </form>
          <mat-spinner
            *ngIf="order.sender.editMode && isLoadingAddresses"
            [diameter]="35"
            color="primary"
          ></mat-spinner>
        </li>

        <li>
          <span class="label">Temps d'attente </span>
          <span *ngIf="order.sender?.waitingTime && !order.sender.editMode">{{
            order.sender.waitingTime | formatHours
          }}</span>
          <span *ngIf="!order.sender.waitingTime && !order.sender.editMode"
            >aucun</span
          >

          <form
            [formGroup]="formStep"
            *ngIf="order.sender.editMode && formStep"
          >
            <mat-form-field class="time-field">
              <mat-label>Temps passé</mat-label>
              <input type="time" matInput formControlName="waitingTime" />
            </mat-form-field>
          </form>
        </li>
      </ul>

      <ul>
        <li>
          <fieldset>
            <legend class="label">Commentaire client/dispatcheur</legend>
            <p *ngIf="!order.sender.editMode && order.sender.ordererComment">
              {{ order.sender.ordererComment }}
            </p>
            <p *ngIf="!order.sender.editMode && !order.sender.ordererComment">
              Aucun
            </p>
            <form
              [formGroup]="formStep"
              *ngIf="order.sender.editMode && formStep"
            >
              <mat-form-field class="site-field">
                <mat-label>Commentaire</mat-label>
                <input type="text" matInput formControlName="ordererComment" />
              </mat-form-field>
            </form>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <legend class="label legendWithPhoto">
              Commentaire chauffeur
              <button
                mat-icon-button
                *ngIf="!order.sender.editMode && order.sender.hasPhoto"
                color="primary"
                class="export-btn"
                (click)="downloadPhoto(order.sender)"
                matTooltip="Télécharger la photo"
              >
                <mat-icon aria-label="File">photo_camera</mat-icon>
              </button>
            </legend>
            <p *ngIf="!order.sender.editMode && order.sender.driverComment">
              {{ order.sender.driverComment }}
            </p>
            <p *ngIf="!order.sender.editMode && !order.sender.driverComment">
              Aucun
            </p>

            <form
              [formGroup]="formStep"
              *ngIf="order.sender.editMode && formStep"
            >
              <mat-form-field class="site-field">
                <mat-label>Commentaire</mat-label>
                <input type="text" matInput formControlName="driverComment" />
              </mat-form-field>
            </form>
          </fieldset>
        </li>
      </ul>
    </section>
  </mat-expansion-panel>

  <!-- RECEIVERS -->
  <ng-container>
    <mat-expansion-panel
      *ngFor="let receiver of order.receivers; index as i"
      [expanded]="true"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span *ngIf="!isTour() && receiver.isPickup"
            >Expédition - &nbsp;</span
          >
          <span *ngIf="!isTour() && receiver.isDelivery"
            >Destinataire - &nbsp;</span
          >
          Étape {{ i + 2 }}
          <span *ngIf="isTour() && receiver.isExtraStep"
            >&nbsp;(supplémentaire)</span
          >
          <button
            [disabled]="stepOnEditMode"
            *ngIf="isSuperAdmin && !receiver.editMode"
            (click)="modifyStep(receiver); $event.stopPropagation()"
            mat-raised-button
            color="primary"
            type="button"
          >
            Modifier
          </button>
          <button
            *ngIf="isSuperAdmin && receiver.editMode && formStep"
            (click)="validateNewStep(receiver); $event.stopPropagation()"
            [disabled]="formStep.invalid || formStep.pristine"
            mat-raised-button
            color="primary"
            type="button"
          >
            Valider
          </button>
          <button
            *ngIf="isSuperAdmin && receiver.editMode"
            (click)="cancelNewStep(receiver); $event.stopPropagation()"
            mat-raised-button
            color="primary"
            class="cancelButton"
            type="button"
          >
            Annuler
          </button>
        </mat-panel-title>
        <mat-panel-description>
          <span class="italic" *ngIf="!isTour() && receiver.isPickup"
            >Enlèvement</span
          ><span class="italic" *ngIf="!isTour() && receiver.isDelivery"
            >Livraison</span
          >
          <mat-icon *ngIf="!isTour() && receiver.isPickup" color="primary">
            local_shipping
          </mat-icon>
          <mat-icon *ngIf="!isTour() && receiver.isDelivery" color="primary">
            location_on
          </mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <section class="wrapperStep">
        <ul class="listPanel">
          <li *ngIf="receiver.address && !receiver.otherAddress">
            <span class="label">Nom d'adresse </span>
            <span *ngIf="!receiver.editMode">{{ receiver.address.name }}</span>
          </li>
          <li *ngIf="receiver.otherAddress">
            <span class="label">Nom d'adresse </span>
            <span *ngIf="!receiver.editMode">{{ receiver.otherAddress }}</span>
          </li>
          <li *ngIf="receiver.editMode && formStep" class="stepAddress">
            <form
              [formGroup]="formStep"
              *ngIf="!isLoadingAddresses && receiver.editMode && formStep"
            >
              <app-autocomplete
                class="site-field"
                [control]="getControlAddressStep()"
                [list]="receivers"
                errorMsg="orders.create.sender.errorMessage"
                [canString]="canAddOtherAddress"
              >
              </app-autocomplete>
            </form>
          </li>
          <mat-spinner
            *ngIf="receiver.editMode && isLoadingAddresses"
            [diameter]="35"
            color="primary"
          ></mat-spinner>
          <li>
            <span class="label">Service </span>
            <span *ngIf="!receiver.editMode && receiver.service">{{
              receiver.service
            }}</span>

            <form [formGroup]="formStep" *ngIf="receiver.editMode && formStep">
              <app-autocomplete-text
                class="site-field stepAddress"
                [control]="getControlServiceStep()"
                [list]="getControlAddressStep().value?.services"
              >
              </app-autocomplete-text>
            </form>
          </li>

          <li *ngIf="receiver.requestedDate">
            <span class="label">Date de passage souhaitée</span>
            {{ receiver.requestedDate | amDateFormat: "DD/MM/YYYY HH:mm" }}
          </li>

          <li *ngIf="receiver.hasSignature">
            <span class="label">Signataire </span>{{ receiver.signatory }}
          </li>
          <li *ngIf="receiver.hasSignature">
            <button
              mat-raised-button
              color="primary"
              (click)="downloadSignature(receiver)"
            >
              Télécharger signature
            </button>
          </li>
        </ul>

        <ul>
          <li *ngIf="receiver.address && !receiver.otherAddress">
            <span class="label">Adresse complète </span>
            {{ receiver.address.street }} {{ receiver.address.streetNumber }}
            {{ receiver.address.locality }} {{ receiver.address.postalCode }}
          </li>
          <li *ngIf="receiver.arrivedOn">
            <span class="label">Arrivée sur place </span>
            <span *ngIf="!receiver.editMode">{{
              receiver.arrivedOn | amDateFormat: "DD/MM/YYYY HH:mm"
            }}</span>
            <!-- <span *ngIf="receiver.editMode">{{receiver.arrivedOn | amDateFormat: 'DD/MM/YYYY'}}</span> -->
            <form
              [formGroup]="formStep"
              *ngIf="receiver.editMode && formStep && !isLoadingAddresses"
            >
              <mat-form-field class="date-field">
                <mat-label>Arrivée sur place</mat-label>
                <input
                  matInput
                  [matDatepicker]="arrivedOnDate"
                  (click)="arrivedOnDate.open()"
                  (focus)="arrivedOnDate.open()"
                  formControlName="arrivedOn"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="arrivedOnDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #arrivedOnDate></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="time-field">
                <mat-label>Heure</mat-label>
                <input type="time" matInput formControlName="arrivedTime" />
              </mat-form-field>
            </form>
            <mat-spinner
              *ngIf="receiver.editMode && isLoadingAddresses"
              [diameter]="35"
              color="primary"
            ></mat-spinner>
          </li>
          <li *ngIf="receiver.arrivedOn">
            <span class="label">Tag NFC </span>
            <span *ngIf="receiver.tagScanned">{{ receiver.tagScanned }}</span>
            <span *ngIf="!receiver.tagScanned">Aucun</span>
          </li>
          <li *ngIf="receiver.completedOn">
            <span class="label" *ngIf="!isTour() && receiver.isPickup"
              >Expédié le
            </span>
            <span class="label" *ngIf="!isTour() && receiver.isDelivery"
              >Livré le
            </span>
            <span class="label" *ngIf="isTour()">Terminée le </span>
            <span *ngIf="!receiver.editMode">{{
              receiver.completedOn | amDateFormat: "DD/MM/YYYY HH:mm"
            }}</span>
            <!-- <span *ngIf="receiver.editMode">{{receiver.completedOn | amDateFormat: 'DD/MM/YYYY'}}</span> -->
            <form
              [formGroup]="formStep"
              *ngIf="receiver.editMode && formStep && !isLoadingAddresses"
            >
              <mat-form-field class="date-field">
                <mat-label *ngIf="!isTour()">Expédié le</mat-label>
                <mat-label *ngIf="isTour()">Terminée le</mat-label>
                <input
                  matInput
                  [matDatepicker]="completedOnDate"
                  (click)="completedOnDate.open()"
                  (focus)="completedOnDate.open()"
                  formControlName="completedOn"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="completedOnDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #completedOnDate></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="time-field">
                <mat-label>Heure</mat-label>
                <input type="time" matInput formControlName="completedTime" />
              </mat-form-field>
            </form>
            <mat-spinner
              *ngIf="receiver.editMode && isLoadingAddresses"
              [diameter]="35"
              color="primary"
            ></mat-spinner>
          </li>

          <li>
            <span class="label">Temps d'attente </span>
            <span *ngIf="receiver?.waitingTime && !receiver.editMode">{{
              receiver.waitingTime | formatHours
            }}</span>
            <span *ngIf="!receiver.waitingTime && !receiver.editMode"
              >aucun</span
            >

            <form [formGroup]="formStep" *ngIf="receiver.editMode && formStep">
              <mat-form-field class="time-field">
                <mat-label>Temps passé</mat-label>
                <input type="time" matInput formControlName="waitingTime" />
              </mat-form-field>
            </form>
          </li>
        </ul>

        <ul>
          <li>
            <fieldset>
              <legend class="label">Commentaire client/dispatcheur</legend>
              <p *ngIf="!receiver.editMode && receiver.ordererComment">
                {{ receiver.ordererComment }}
              </p>
              <p *ngIf="!receiver.editMode && !receiver.ordererComment">
                Aucun
              </p>
              <form
                [formGroup]="formStep"
                *ngIf="receiver.editMode && formStep"
              >
                <mat-form-field class="site-field">
                  <mat-label>Commentaire</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="ordererComment"
                  />
                </mat-form-field>
              </form>
            </fieldset>
          </li>
          <li>
            <fieldset>
              <legend class="label legendWithPhoto">
                Commentaire chauffeur
                <button
                  mat-icon-button
                  *ngIf="!receiver.editMode && receiver.hasPhoto"
                  color="primary"
                  class="export-btn"
                  (click)="downloadPhoto(receiver)"
                  matTooltip="Télécharger la photo"
                >
                  <mat-icon aria-label="File">photo_camera</mat-icon>
                </button>
              </legend>
              <p *ngIf="!receiver.editMode && receiver.driverComment">
                {{ receiver.driverComment }}
              </p>
              <p *ngIf="!receiver.editMode && !receiver.driverComment">Aucun</p>

              <form
                [formGroup]="formStep"
                *ngIf="receiver.editMode && formStep"
              >
                <mat-form-field class="site-field">
                  <mat-label>Commentaire</mat-label>
                  <input type="text" matInput formControlName="driverComment" />
                </mat-form-field>
              </form>
            </fieldset>
          </li>
        </ul>
      </section>

      <section class="sectionTable" *ngIf="receiver.patients.length > 0">
        <h3 class="label">Patients</h3>
        <app-order-step-patients-table
          [patients]="receiver.patients"
        ></app-order-step-patients-table>
      </section>
    </mat-expansion-panel>
  </ng-container>

  <mat-expansion-panel *ngIf="order.statusChanges.length > 0">
    <mat-expansion-panel-header>
      <mat-panel-title> Historique </mat-panel-title>
      <mat-panel-description>
        Historique des modifications de la commande
        <mat-icon color="primary">history_edu</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <section class="sectionTable">
      <mat-table
        [dataSource]="history"
        class="mat-elevation-z2 statusTable"
        *ngIf="order.statusChanges.length > 0"
        matSort
        #TableHistorySort="matSort"
      >
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Statut
          </mat-header-cell>
          <mat-cell *matCellDef="let statusChange">
            {{ showStatusText(statusChange.status) | translate }}
          </mat-cell>
        </ng-container>

        <ng-container *ngIf="!isClient" matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Commentaire
          </mat-header-cell>
          <mat-cell *matCellDef="let statusChange" class="commentCell">
            <span *ngIf="statusChange.comment">{{ statusChange.comment }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdBy">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Par
          </mat-header-cell>
          <mat-cell *matCellDef="let statusChange">
            <span *ngIf="statusChange.createdBy">{{
              statusChange.createdBy.username
            }}</span>
            <span *ngIf="!statusChange.createdBy">Système</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Date
          </mat-header-cell>
          <mat-cell *matCellDef="let statusChange">
            {{ statusChange.createdOn | amDateFormat: "DD/MM/YYYY HH:mm" }}
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumnsHistory"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumnsHistory"
        ></mat-row>
      </mat-table>
      <mat-paginator
        #TableHistoryPaginator
        *ngIf="order.statusChanges.length > 0"
        [pageSize]="6"
        [length]="order.statusChanges.length"
        showFirstLastButtons
      ></mat-paginator>
    </section>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="order.sender.scans.length > 0">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span *ngIf="!isTour()"> Produit(s) expédié(s) </span>
        <span *ngIf="isTour()">
          <b>{{ order.sender.countDeliveryScan() }}</b> produit(s) livré(s) et
          <b>{{ order.sender.countPickupScan() }}</b> produit(s) expédié(s) pour
          l'étape - 1</span
        >
      </mat-panel-title>

      <mat-panel-description>
        <span class="italic" *ngIf="!isTour()"> Enlèvement</span>
        <mat-icon color="primary" *ngIf="!isTour()">local_shipping</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <section class="sectionTable">
      <app-order-step-scans-table
        [isTour]="isTour()"
        [scans]="order.sender.scans"
        [allScans]="allScans"
        [orderStartDate]="order.startDate"
        [clientId]="order.client.id"
      ></app-order-step-scans-table>
    </section>
  </mat-expansion-panel>

  <ng-container *ngFor="let receiver of order.receivers; index as i">
    <mat-expansion-panel *ngIf="receiver.scans.length > 0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span *ngIf="!isTour() && receiver.isPickup"
            >Produit(s) expédié(s) du Destinataire - {{ i + 1 }}</span
          >
          <span *ngIf="!isTour() && receiver.isDelivery"
            >Produit(s) livré(s) au Destinataire - {{ i + 1 }}</span
          >
          <span *ngIf="isTour()">
            <b>{{ receiver.countDeliveryScan() }}</b> produit(s) livré(s) et
            <b>{{ receiver.countPickupScan() }}</b> produit(s) expédié(s) pour
            l'étape - {{ i + 2 }}</span
          >
        </mat-panel-title>
        <mat-panel-description>
          <span class="italic" *ngIf="!isTour() && receiver.isPickup"
            >Enlèvement</span
          ><span class="italic" *ngIf="!isTour() && receiver.isDelivery"
            >Livraison</span
          >
          <mat-icon *ngIf="!isTour() && receiver.isPickup" color="primary">
            local_shipping
          </mat-icon>
          <mat-icon *ngIf="!isTour() && receiver.isDelivery" color="primary">
            location_on
          </mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <section class="sectionTable">
        <app-order-step-scans-table
          [isTour]="isTour()"
          [scans]="receiver.scans"
          [allScans]="allScans"
          [orderStartDate]="order.startDate"
          [clientId]="order.client.id"
        ></app-order-step-scans-table>
      </section>
    </mat-expansion-panel>
  </ng-container>
</mat-accordion>

<app-order-edit
  *ngIf="onEditMode && order.type !== orderType.transmission"
  [order]="order"
  (editFinished)="onEditFinished()"
></app-order-edit>

<app-order-transmission-edit
  *ngIf="onEditMode && order.type === orderType.transmission"
  [order]="order"
  (editFinished)="onEditFinished()"
></app-order-transmission-edit>

<!--
  TEMPLATE PDF
 -->

<div *ngIf="!onEditMode" id="toPdf" #toPdf class="toPdf hidden">
  <span style="font-size: 10px">
    <p style="font-size: 16px; font-weight: bold">
      Feuille &nbsp; de &nbsp; route | Donneur &nbsp; d'ordre &nbsp; : &nbsp;
      {{ this.order.site.name }}
    </p>
    <div
      style="
        border: 1px solid black;
        border-radius: 4px;
        padding: 10px;
        margin-top: 20px;
      "
    >
      <div style="font-weight: bold">Infos de la commande</div>
      <div style="display: flex; justify-content: space-between">
        <ul
          style="list-style: none; margin: 0; padding: 0; margin: 0; padding: 0"
        >
          <li class="titleStatus">
            <span style="font-weight: bold">N°{{ order.identifier }}</span>
            <br />
            <span style="font-weight: bold; color: #258bc9">Statut </span>
            <span *ngIf="order.status">{{
              showStatusText(order.status) | translate
            }}</span>
            <br />
            <span style="font-weight: bold; color: #258bc9"
              >Type de commande
            </span>
            <span>{{ showTypeText(order.type) | translate }}</span>
          </li>
        </ul>

        <ul style="list-style: none; margin: 0; padding: 0">
          <li>
            <span style="font-weight: bold; color: #258bc9"
              >Niveau d'urgence
            </span>
            <span *ngIf="order.urgency && !editInfos">{{
              order.urgency.name
            }}</span>
          </li>

          <li>
            <span style="font-weight: bold; color: #258bc9"
              >Type de produits</span
            >
            <ul
              *ngIf="order.transportTypes.length > 0"
              style="list-style: none"
            >
              <li *ngFor="let type of order.transportTypes">
                - {{ type.name }}
              </li>
            </ul>
            <span *ngIf="order.transportTypes.length === 0"
              >Aucun type de produits</span
            >
          </li>
        </ul>

        <ul style="list-style: none; margin: 0; padding: 0">
          <li class="global-driver">
            <div>
              <span style="font-weight: bold; color: #258bc9">Chauffeur </span>
              <span *ngIf="order.driver">{{ order.driver.username }}</span>
              <span *ngIf="!order.driver">Aucun chauffeur</span>
            </div>
          </li>

          <li *ngIf="order.vehicle">
            <span style="font-weight: bold; color: #d32f2f">Véhicule </span>
            <span *ngIf="order.vehicle?.numberplate">{{
              order.vehicle.numberplate
            }}</span>
          </li>

          <li>
            <span style="font-weight: bold; color: #258bc9">Agence </span>
            <span *ngIf="order.client">{{ order.client.name }}</span>
          </li>

          <li *ngIf="order.status !== 16">
            <span style="font-weight: bold; color: #258bc9"
              >Nombre de destination(s)
            </span>
            <span>{{ totalSteps }}</span>
          </li>

          <li>
            <span style="font-weight: bold; color: #258bc9"
              >Date de livraison souhaitée
            </span>
            <span *ngIf="order.startDate && !editInfos">{{
              order.startDate | amDateFormat: "DD/MM/YYYY HH:mm"
            }}</span>
            <span *ngIf="order.startDate && editInfos">{{
              order.startDate | amDateFormat: "DD/MM/YYYY"
            }}</span>
          </li>

          <!-- <li>
            <span style="font-weight: bold;color: #258bc9;">Heure de l'appel </span>
            <span *ngIf="order.callDate">{{ order.callDate | amDateFormat: 'HH:mm'}}</span>
          </li> -->
        </ul>
      </div>
    </div>

    <br />

    <!-- SENDER -->
    <div style="border: 1px solid black; border-radius: 4px; padding: 10px">
      <div
        *ngIf="!isTour()"
        style="display: flex; align-items: center; font-weight: bold"
      >
        Expédition - Étape 1 <i>- Enlèvement</i>
      </div>

      <div
        *ngIf="isTour()"
        style="display: flex; align-items: center; font-weight: bold"
      >
        Étape 1
      </div>

      <div style="display: flex; justify-content: space-between">
        <ul style="list-style: none; margin: 0; padding: 0">
          <li *ngIf="order.sender.address && !order.sender.otherAddress">
            <span style="font-weight: bold; color: #258bc9"
              >Nom d'adresse
            </span>
            <span *ngIf="!order.sender.editMode">{{
              order.sender.address.name
            }}</span>
          </li>
          <li *ngIf="order.sender.otherAddress">
            <span style="font-weight: bold; color: #258bc9"
              >Nom d'adresse
            </span>
            <span *ngIf="!order.sender.editMode">{{
              order.sender.otherAddress
            }}</span>
          </li>
          <mat-spinner
            *ngIf="order.sender.editMode && isLoadingAddresses"
            [diameter]="35"
            color="primary"
          ></mat-spinner>
          <li *ngIf="order.sender.service">
            <span style="font-weight: bold; color: #258bc9">Service </span
            >{{ order.sender.service }}
          </li>

          <li *ngIf="order.sender.hasSignature">
            <span style="font-weight: bold; color: #258bc9">Signataire </span
            >{{ order.sender.signatory }}
          </li>
        </ul>

        <ul style="list-style: none; margin: 0; padding: 0">
          <li *ngIf="order.sender.address && !order.sender.otherAddress">
            <span style="font-weight: bold; color: #258bc9"
              >Adresse complète
            </span>
            <span
              >{{ order.sender.address.street }}
              {{ order.sender.address.streetNumber }}
              {{ order.sender.address.locality }}
              {{ order.sender.address.postalCode }}</span
            >
          </li>
          <li *ngIf="order.sender.arrivedOn">
            <span style="font-weight: bold; color: #258bc9"
              >Arrivée sur place
            </span>
            <span *ngIf="!order.sender.editMode">{{
              order.sender.arrivedOn | amDateFormat: "DD/MM/YYYY HH:mm"
            }}</span>
            <span *ngIf="order.sender.editMode">{{
              order.sender.arrivedOn | amDateFormat: "DD/MM/YYYY"
            }}</span>
          </li>
          <li *ngIf="order.sender.arrivedOn">
            <span style="font-weight: bold; color: #258bc9">Tag NFC </span>
            <span *ngIf="order.sender.tagScanned">{{
              order.sender.tagScanned
            }}</span>
            <span *ngIf="!order.sender.tagScanned">Aucun</span>
          </li>
          <li *ngIf="order.sender.completedOn">
            <span *ngIf="!isTour()" style="font-weight: bold; color: #258bc9"
              >Expédié le
            </span>
            <span *ngIf="isTour()" style="font-weight: bold; color: #258bc9"
              >Terminée le
            </span>
            <span *ngIf="!order.sender.editMode">{{
              order.sender.completedOn | amDateFormat: "DD/MM/YYYY HH:mm"
            }}</span>
            <span *ngIf="order.sender.editMode">{{
              order.sender.completedOn | amDateFormat: "DD/MM/YYYY"
            }}</span>
          </li>
          <li *ngIf="order.sender.waitingTime">
            <span style="font-weight: bold; color: #258bc9"
              >Temps d'attente
            </span>
            <span>{{ order.sender.waitingTime }} min</span>
          </li>
          <li *ngIf="order.sender?.scans?.length > 0">
            <span
              style="font-weight: bold; color: #258bc9"
              *ngIf="!isTour() && order.sender.isPickup"
            >
              Produit(s) transporté(s)
            </span>
            <span
              style="font-weight: bold; color: #258bc9"
              *ngIf="!isTour() && order.sender.isDelivery"
            >
              Produit(s) livré(s)
            </span>
            <span style="font-weight: bold; color: #258bc9" *ngIf="isTour()">
              Produit(s) livré(s)/transporté(s)
            </span>

            <ul style="list-style: none">
              <li *ngFor="let scan of order.sender.scans">
                <span *ngIf="scan.code">- {{ scan.code }}</span>
                <span *ngIf="!scan.code"
                  >- {{ scan.container.description }}
                  <ng-container *ngIf="scan.temperature">
                    {{ scan.temperature.startTemperature ? (scan.temperature.startTemperature | signedTemperature) + "°C" : "" }}

                    {{ scan.temperature.endTemperature ? (" / " + (scan.temperature.endTemperature | signedTemperature) + "°C") : "" }}

                    <ng-container *ngIf="scan.temperature.temperatureExceeded">
                      <span style="color: red; font-weight: bold"> !</span>
                    </ng-container>
                  </ng-container>
                </span>
                <span *ngIf="isTour() && scan.type === 1"> (retrait)</span>
                <span *ngIf="isTour() && scan.type === 2"> (livraison)</span>
              </li>
            </ul>
          </li>
        </ul>

        <ul style="list-style: none; margin: 0; padding: 0">
          <li>
            <span style="font-weight: bold; color: #258bc9"
              >Commentaire client/dispatcheur</span
            >
            <div
              style="border: 1px solid black; border-radius: 4px; padding: 5px"
            >
              <p *ngIf="order.sender.ordererComment">
                {{ order.sender.ordererComment }}
              </p>
              <p *ngIf="!order.sender.ordererComment">Aucun</p>
            </div>
          </li>
          <li>
            <span style="font-weight: bold; color: #258bc9"
              >Commentaire chauffeur</span
            >
            <div
              style="border: 1px solid black; border-radius: 4px; padding: 5px"
            >
              <p *ngIf="order.sender.driverComment">
                {{ order.sender.driverComment }}
              </p>
              <p *ngIf="!order.sender.driverComment">Aucun</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <br />

    <!--
    RECEIVERS
   -->

    <ng-container>
      <div
        *ngFor="let receiver of order.receivers; index as i"
        style="
          border: 1px solid black;
          border-radius: 4px;
          margin-bottom: 20px;
          padding: 10px;
        "
      >
        <div style="display: flex; align-items: center; font-weight: bold">
          <span *ngIf="!isTour() && receiver.isPickup">Expédition - </span>
          <span *ngIf="!isTour() && receiver.isDelivery">Destinataire - </span>
          <span *ngIf="!isTour()">&nbsp;</span>
          Étape {{ i + 2 }}
          <span *ngIf="isTour() && receiver.isExtraStep"
            >&nbsp;(supplémentaire)</span
          >
          <span *ngIf="!isTour()">&nbsp;</span>
          <i *ngIf="!isTour() && receiver.isPickup"> - Enlèvement</i>
          <i *ngIf="!isTour() && receiver.isDelivery"> - Livraison</i>
        </div>

        <div style="display: flex; justify-content: space-between">
          <ul style="list-style: none; margin: 0; padding: 0">
            <li *ngIf="receiver.address && !receiver.otherAddress">
              <span style="font-weight: bold; color: #258bc9"
                >Nom d'adresse
              </span>
              <span *ngIf="!receiver.editMode">
                {{ receiver.address.name }}</span
              >
            </li>
            <li *ngIf="receiver.otherAddress">
              <span style="font-weight: bold; color: #258bc9"
                >Nom d'adresse
              </span>
              <span *ngIf="!receiver.editMode">
                {{ receiver.otherAddress }}</span
              >
            </li>
            <li *ngIf="receiver.service">
              <span style="font-weight: bold; color: #258bc9">Service </span
              >{{ receiver.service }}
            </li>

            <li *ngIf="receiver.hasSignature">
              <span style="font-weight: bold; color: #258bc9">Signataire </span
              >{{ receiver.signatory }}
            </li>
          </ul>

          <ul style="list-style: none; margin: 0; padding: 0">
            <li *ngIf="receiver.address && !receiver.otherAddress">
              <span style="font-weight: bold; color: #258bc9"
                >Adresse complète
              </span>
              {{ receiver.address.street }}
              {{ receiver.address.streetNumber }}
              {{ receiver.address.locality }} {{ receiver.address.postalCode }}
            </li>
            <li *ngIf="receiver.arrivedOn">
              <span style="font-weight: bold; color: #258bc9"
                >Arrivée sur place
              </span>
              <span *ngIf="!receiver.editMode">{{
                receiver.arrivedOn | amDateFormat: "DD/MM/YYYY HH:mm"
              }}</span>
              <span *ngIf="receiver.editMode">{{
                receiver.arrivedOn | amDateFormat: "DD/MM/YYYY"
              }}</span>
            </li>
            <li *ngIf="receiver.arrivedOn">
              <span style="font-weight: bold; color: #258bc9">Tag NFC </span>
              <span *ngIf="receiver.tagScanned">{{ receiver.tagScanned }}</span>
              <span *ngIf="!receiver.tagScanned">Aucun</span>
            </li>
            <li *ngIf="receiver.completedOn">
              <span
                style="font-weight: bold; color: #258bc9"
                *ngIf="!isTour() && receiver.isPickup"
                >Expédié le
              </span>
              <span
                style="font-weight: bold; color: #258bc9"
                *ngIf="!isTour() && receiver.isDelivery"
                >Livré le
              </span>
              <span style="font-weight: bold; color: #258bc9" *ngIf="isTour()"
                >Terminée le
              </span>
              <span *ngIf="!receiver.editMode">{{
                receiver.completedOn | amDateFormat: "DD/MM/YYYY HH:mm"
              }}</span>
              <span *ngIf="receiver.editMode">{{
                receiver.completedOn | amDateFormat: "DD/MM/YYYY"
              }}</span>
            </li>
            <li *ngIf="receiver.waitingTime">
              <span style="font-weight: bold; color: #258bc9"
                >Temps d'attente
              </span>
              <span>{{ receiver.waitingTime }} min</span>
            </li>
            <li *ngIf="receiver.scans?.length > 0">
              <span
                style="font-weight: bold; color: #258bc9"
                *ngIf="!isTour() && receiver.isPickup"
              >
                Produit(s) transporté(s)
              </span>
              <span
                style="font-weight: bold; color: #258bc9"
                *ngIf="!isTour() && receiver.isDelivery"
              >
                Produit(s) livré(s)
              </span>
              <span style="font-weight: bold; color: #258bc9" *ngIf="isTour()">
                Produit(s) livré(s)/transporté(s)
              </span>

              <ul style="list-style: none">
                <li *ngFor="let scan of receiver.scans">
                  <span *ngIf="scan.code">- {{ scan.code }}</span>
                  <span *ngIf="!scan.code"
                    >- {{ scan.container.description }}
                    <ng-container *ngIf="scan.temperature">
                      <ng-container
                        *ngIf="!scan.temperature.temperatureExceeded"
                      >
                        <mat-icon style="color: red">cancel</mat-icon>
                      </ng-container>

                      {{
                        scan.temperature.startTemperature
                          ? scan.temperature.startTemperature + "°C"
                          : ""
                      }}

                      {{
                        scan.temperature.endTemperature
                          ? " / " + scan.temperature.endTemperature + "��C"
                          : ""
                      }}

                      <ng-container
                        *ngIf="scan.temperature.temperatureExceeded"
                      >
                        <span style="color: red; font-weight: bold"> !</span>
                      </ng-container>
                    </ng-container>
                  </span>
                  <span *ngIf="isTour() && scan.type === 1"> (retrait)</span>
                  <span *ngIf="isTour() && scan.type === 2"> (livraison)</span>
                </li>
              </ul>
            </li>
          </ul>

          <ul style="list-style: none; margin: 0; padding: 0">
            <li>
              <span style="font-weight: bold; color: #258bc9"
                >Commentaire client/dispatcheur</span
              >
              <div
                style="
                  border: 1px solid black;
                  border-radius: 4px;
                  padding: 5px;
                "
              >
                <p *ngIf="receiver.ordererComment">
                  {{ receiver.ordererComment }}
                </p>
                <p *ngIf="!receiver.ordererComment">Aucun</p>
              </div>
            </li>
            <li>
              <span style="font-weight: bold; color: #258bc9">
                Commentaire chauffeur
              </span>
              <div
                style="
                  border: 1px solid black;
                  border-radius: 4px;
                  padding: 5px;
                "
              >
                <p *ngIf="receiver.driverComment">
                  {{ receiver.driverComment }}
                </p>
                <p *ngIf="!receiver.driverComment">Aucun</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
  </span>
</div>
